import React from "react"
import { useIntl } from "react-intl"
import { REASON_SESSION_EXPIRED } from "constants/session"
import { Alert } from "@walmart-web/livingdesign-components"

const LoginExpirationMessage: React.FC<Function> = (): JSX.Element => {
	const storagedSession = sessionStorage.getItem("SESSION_EXPIRATION")
	const intl = useIntl()
	const urlSearchParams = new URLSearchParams(location.search)
	const contentMessageAlert = urlSearchParams.get("reason")
	return contentMessageAlert === REASON_SESSION_EXPIRED ||
		storagedSession === REASON_SESSION_EXPIRED ? (
		<Alert UNSAFE_className="alert-message" variant="warning">
			<span className="alert-paragraph">
				{intl.formatMessage({
					id: "phronesis.login.landing.reason.sessionexpired",
				})}
			</span>
			<span className="alert-paragraph">
				{intl.formatMessage({
					id: "phronesis.login.landing.action.loginagain",
				})}
			</span>
		</Alert>
	) : (
		<></>
	)
}

export default LoginExpirationMessage
